(() => {
  if (window.amGlassNavigationMounted) return;
  window.amGlassNavigationMounted = true;
  let observer;
  function measureHeader() {
    const shell = document.querySelector('.header-shell--glass');
    if (!shell) return;
    const announcement = shell.querySelector('.announcement')?.offsetHeight || 0;
    const occupiedHeight = Math.ceil(shell.getBoundingClientRect().height - announcement);
    document.documentElement.style.setProperty('--glass-overlay-height', occupiedHeight + 'px');
    document.documentElement.style.setProperty('--header-height', occupiedHeight + 'px');
    shell.classList.toggle('is-scrolled', scrollY > 100);
  }
  function initialize() {
    observer?.disconnect();
    const shell = document.querySelector('.header-shell--glass');
    if (!shell) return;
    measureHeader();
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(measureHeader);
      observer.observe(shell);
    }
  }
  initialize();
  addEventListener('pageshow', measureHeader);
  addEventListener('resize', measureHeader, { passive: true });
  document.addEventListener('shopify:section:load', initialize);
})();
